import '/src/common/js/onLoad';
import '/src/components/mobile-menu/mobile-menu';
import './home-tabs';
import './apps-swiper';
